module.exports = __webpack_public_path__ + "img/5.75f3d712.jpg";